import React from 'react';
import { createPortal } from 'react-dom';
import './Dialog.scss';

interface Props {
  title?: string;
  Content: string | React.FC;
  visible: boolean;
  onCancel: React.MouseEventHandler;
}

const Dialog: React.FC<Props> = props => {
  const { title, Content, visible, onCancel } = props;

  return createPortal(
    <>
      <div className={`global-mask ${visible ? '' : 'hide'}`} />
      <div className={`dialog-wrapper ${visible ? '' : 'hide'}`}>
        <button className="close-btn" onClick={onCancel} />
        <div className="content">
          {typeof title === 'string' && (
            <h2 className="dialog-title">{title}</h2>
          )}
          {typeof Content === 'string' ? (
            <pre className="desc">{Content}</pre>
          ) : (
            <Content />
          )}
        </div>
      </div>
    </>,
    document.body
  );
};

export default Dialog;
